import axios from '@axios'

// Раздел «Аналитика» (только для админов). Данные из нашей БД — эндпоинты
// /api/v1/analytics/*. Слэш на конце обязателен (иначе 301, см. стор help).
const get = url => axios({ method: 'get', url }).then(r => r.data)

export default {
  namespaced: true,
  state: {
    summary: null,
    payments: null,
    users: null,
    visits: null,
    behavior: null,
    clients: [],
    userActivity: null,
    licenses: null,
  },
  getters: {
    getSummary: state => state.summary,
    getPayments: state => state.payments,
    getUsers: state => state.users,
    getVisits: state => state.visits,
    getBehavior: state => state.behavior,
    getClients: state => state.clients,
    getUserActivity: state => state.userActivity,
    getLicenses: state => state.licenses,
  },
  mutations: {
    setSummary: (state, v) => { state.summary = v },
    setPayments: (state, v) => { state.payments = v },
    setUsers: (state, v) => { state.users = v },
    setVisits: (state, v) => { state.visits = v },
    setBehavior: (state, v) => { state.behavior = v },
    setClients: (state, v) => { state.clients = v },
    setUserActivity: (state, v) => { state.userActivity = v },
    setLicenses: (state, v) => { state.licenses = v },
  },
  actions: {
    fetchSummary: ({ commit }, days = 90) => get(`/api/v1/analytics/summary/?days=${days}`).then(d => commit('setSummary', d)),
    fetchPayments: ({ commit }, days = 90) => get(`/api/v1/analytics/payments/?days=${days}`).then(d => commit('setPayments', d)),
    fetchUsers: ({ commit }, days = 90) => get(`/api/v1/analytics/users/?days=${days}`).then(d => commit('setUsers', d)),
    fetchVisits: ({ commit }, days = 90) => get(`/api/v1/analytics/visits/?days=${days}`).then(d => commit('setVisits', d)),
    fetchBehavior: ({ commit }, days = 90) => get(`/api/v1/analytics/behavior/?days=${days}`).then(d => commit('setBehavior', d)),
    fetchClients: ({ commit }) => get('/api/v1/analytics/clients/').then(d => commit('setClients', (d && d.clients) || [])),

    // ordersDays — свой период у блока «Заявки» (число дней либо 'all').
    fetchUserActivity: ({ commit }, { login, days = 90, ordersDays = 90 }) =>
      get(`/api/v1/analytics/user-activity/?login=${encodeURIComponent(login)}&days=${days}&orders_days=${ordersDays}`)
        .then(d => commit('setUserActivity', d)),
    clearUserActivity: ({ commit }) => commit('setUserActivity', null),

    // «Аналитика → Лицензии»: сезон (0 — текущий), fresh — мимо пятиминутного кэша сервера.
    fetchLicenses: ({ commit }, { season = 0, fresh = false } = {}) =>
      get(`/api/v1/analytics/licenses/?season=${season || 0}${fresh ? '&fresh=1' : ''}`).then(d => commit('setLicenses', d)),
  },
}
